<template>
  <div>
    <div class="form-group" :class="`${styleClass.parentElement} ${wrapClass}`">
      <label :class="`${styleClass.label} ${labelClass}`" :for="inputId">
        <slot>Label</slot>
      </label>
      <div :class="styleClass.input">
        <input
          :type="control"
          class="form-control"
          :id="inputId"
          :value="value"
          :step="control == 'number' && step"
          autocomplete="off"
          :required="required"
          :disabled="disabled"
          :autofocus="autofocus"
          :placeholder="placeholder"
          v-cleave="cleave"
          @input="update($event.target.value)"
          v-if="
            [
              'text',
              'password',
              'radio',
              'checkbox',
              'email',
              'number',
            ].includes(control)
          "
        />

        <textarea
          class="form-control"
          :id="inputId"
          :value="value"
          v-if="control == 'textarea'"
          autocomplete="off"
          :required="required"
          :autofocus="autofocus"
          :disabled="disabled"
          :placeholder="placeholder"
          :rows="rows"
          @input="update($event.target.value)"
          v-autosize
        ></textarea>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "InputControl",
  props: {
    value: [String, Number, Boolean],
    type: {
      type: String,
      default: "stacked",
    },
    required: {
      type: Boolean,
      default: false,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    rows: {
      type: Number,
      default: 0,
    },
    control: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
      default: "",
    },
    step: String,
    cleave: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    wrapClass: {
      type: String,
      default: "",
    },
    labelClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    inputId: function () {
      let id = this.$slots.default[0].text
        .toLowerCase()
        .replace(/[^a-z0-9]+/gi, "-");
      return `input-control-${id}`;
    },
  },
  data() {
    return {
      styleClass: {
        parentElement: "",
        label: "",
        input: "",
      },
      fieldType: "text",
    };
  },
  mounted() {
    if (this.type == "horizontal") {
      this.styleClass.parentElement = "row";
      this.styleClass.label = "col-md-2 col-form-label";
      this.styleClass.input = "col";
    }
  },

  methods: {
    update: function (value) {
      this.$emit("input", value);
    },
  },
};
</script>
